import React from 'react';
import './ColumnTemplates.css';

// TEMPLATE 1: Two Equal Columns
export const TwoColumnEqual = ({ leftContent, rightContent }) => {
  return (
    <div className="column-layout two-equal">
      <div className="panel-section column-left">
        {leftContent}
      </div>
      <div className="panel-section column-right">
        {rightContent}
      </div>
    </div>
  );
};

// TEMPLATE 2: One Big Column (Full Width)
export const OneColumnFull = ({ content }) => {
  return (
    <div className="column-layout one-full">
      <div className="panel-section column-full">
        {content}
      </div>
    </div>
  );
};

// TEMPLATE 3: Three Equal Columns
export const ThreeColumnEqual = ({ leftContent, centerContent, rightContent }) => {
  return (
    <div className="column-layout three-equal">
      <div className="panel-section column-left">
        {leftContent}
      </div>
      <div className="panel-section column-center">
        {centerContent}
      </div>
      <div className="panel-section column-right">
        {rightContent}
      </div>
    </div>
  );
};

// TEMPLATE 4: Two Columns (1/3 + 2/3 split)
export const TwoColumnSplit = ({ leftContent, rightContent }) => {
  return (
    <div className="column-layout two-split">
      <div className="panel-section column-small">
        {leftContent}
      </div>
      <div className="panel-section column-large">
        {rightContent}
      </div>
    </div>
  );
};

// TEMPLATE 5: Four Equal Columns
export const FourColumnEqual = ({ col1, col2, col3, col4 }) => {
  return (
    <div className="column-layout four-equal">
      <div className="panel-section column-quarter">
        {col1}
      </div>
      <div className="panel-section column-quarter">
        {col2}
      </div>
      <div className="panel-section column-quarter">
        {col3}
      </div>
      <div className="panel-section column-quarter">
        {col4}
      </div>
    </div>
  );
};

// TEMPLATE 6: Two Rows, Two Columns Each
export const TwoByTwo = ({ topLeft, topRight, bottomLeft, bottomRight }) => {
  return (
    <div className="column-layout two-by-two">
      <div className="panel-section column-top-left">
        {topLeft}
      </div>
      <div className="panel-section column-top-right">
        {topRight}
      </div>
      <div className="panel-section column-bottom-left">
        {bottomLeft}
      </div>
      <div className="panel-section column-bottom-right">
        {bottomRight}
      </div>
    </div>
  );
};

export default {
  TwoColumnEqual,
  OneColumnFull,
  ThreeColumnEqual,
  TwoColumnSplit,
  FourColumnEqual,
  TwoByTwo
};